<cdk-virtual-scroll-viewport class="ion-content-scroll-host" itemSize="44" minBufferPx="800" maxBufferPx="1300">
  <ion-grid class="ion-content-scroll-host">
    <ion-row class="header ion-hide-xl-down" [class.has-actions]="settings.hasActions">
      <ion-col
        *ngFor="let column of settings.columns"
        [id]="'header_' + column.key"
        [size]="settings.autoSize ? 'auto' : column.size === 0 ? 'auto' : column.size"
        [class.sort]="column.sort"
        [ngClass]="[column.position ?? 'center', 'col_header-' + column.key]"
      >
        <ion-text>{{ column.header }}</ion-text>
        <ion-button *ngIf="column.sort" [class.active]="sortDirection.key === column.key" fill="clear" (click)="onSort(column.key)">
          <fa-icon *ngIf="sortDirection.key !== column.key || sortDirection.direction === 'asc'" slot="icon-only" [icon]="faArrowUp"></fa-icon>
          <fa-icon *ngIf="sortDirection.key === column.key && sortDirection.direction === 'desc'" slot="icon-only" [icon]="faArrowDown"></fa-icon>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row *cdkVirtualFor="let item of data; let odd = odd; let index = index" [class.odd-row]="odd" [class.has-actions]="settings.hasActions">
      <ion-col
        *ngFor="let column of settings.columns"
        [id]="column.key"
        [attr.size-xl]="settings.autoSize ? 'auto' : column.size === 0 ? 'auto' : column.size"
        size="12"
        [ngClass]="[column.position ?? 'center', 'col-' + column.key]"
      >
        <ion-label color="medium" class="ion-hide-xl-up">{{ column.header }}: </ion-label>
        <div [ngSwitch]="column.type">
          <span *ngSwitchCase="'constants'">
            {{ column.textConstants[+item[column.key]] }}
          </span>
          <span *ngSwitchCase="'date'">
            {{ item[column.key] | date }}
          </span>
          <ion-badge *ngSwitchCase="'badge'" [color]="column.badgeConstants[+item[column.key]]">
            {{ column.textConstants[+item[column.key]] }}
          </ion-badge>
          <ng-container *ngSwitchCase="'template'">
            <ng-container *ngTemplateOutlet="rowTemplates[column.key]; context: { $implicit: item, index: index }"></ng-container>
          </ng-container>
          <span *ngSwitchDefault>
            {{ item[column.key] }}
          </span>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</cdk-virtual-scroll-viewport>
